<template>
    <div class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Mes Exceptions</h2>
        </div>
        <div class="p-[6px] rounded-xl mb-[8px] bg-[#fff3ea] text-[#bf6d2e]">
            <p class="text-[12px] font-extralight">
                Veuillez appuyé sur le bouton "voir les détails" pour valider les requêtes effectués par les membres de votre équipes
            </p>
        </div>
        <div class="w-full mb-[16px]">
            <CustomTable :data="activeTab" :columnsCustom="columnn" :load="isload">
                <template #other-filter>
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-x-[8px]">
                            <button v-on:click="getAllUserException('refresh')" :disabled="isload" class="size-[35px] border rounded-xl flex items-center justify-center">
                                <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                            </button>

                            <button :class="['h-[35px] px-[12px] text-[#fa3232] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':active == 'Absence'}]" @click="selectfilter('Absence')">
                                <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                                Absences
                            </button>

                            <button :class="['h-[35px] px-[12px] text-[#fa9832] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':active == 'Retards'}]" @click="selectfilter('Retards')">
                                <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                                Rétards
                            </button>

                            <button :class="['h-[35px] text-[#3267fa] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':active == 'Départs'}]" @click="selectfilter('Départs')">
                                <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                                Départs anticipés
                            </button>

                            <div class="inline-block relative">
                                <button @click="show_advanced = !show_advanced" :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':show_advanced}]">
                                    <SlidersHorizontal color="#2b2b2b" :size="16" strokeWidth="1.3"/>
                                    Filtre
                                </button>
                                <Transition @before-enter="beforeEnterBox" @enter="enterBox" @leave="leaveBox">
                                    <div v-if="show_advanced" id="advanced-filter" class="flex items-center gap-x-[12px] text-black font-light rounded-3xl p-6 shadow bg-white border absolute top-[120%] left-1/2 z-10">
                                        <div class="flex items-center gap-x-[8px]">
                                            <label for="date" class="font-light">Date:</label>
                                            <input type="date" v-model="date" name="date" class="h-[35px] w-[130px] cursor-pointer p-3 rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                        </div>
                                        <button v-on:click="getAllUserException" :disabled="isload || actu_load" class="h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light">
                                            Actualiser
                                        </button>
                                        <button @click="show_advanced = !show_advanced" class="size-[25px] rounded-full border flex items-center justify-center">
                                            <X :size="16" strokeWidth="1.3"/>
                                        </button>
                                    </div>
                                </Transition>
                            </div>
                        </div>
                        <button class="bg-[#3c41e9] font-light gap-x-[8px] rounded-xl text-white px-4 h-[35px] flex items-center justify-center">
                            <FolderUp :size="16"/>
                            Exporter
                        </button>
                    </div>
                </template>

                <template #row-cell="slotProps">
                    <span v-if="slotProps.cellNumber == 0" class="flex items-center gap-x-[8px]">
                        {{ slotProps.value }}
                    </span>
                    <span v-else-if="slotProps.cellNumber == 1">
                        {{ formatDate(slotProps.value) }}
                    </span>
                    <span v-else-if="slotProps.cellNumber == 2">
                        <span :class="['px-3 py-1 rounded-lg',{'bg-[#d7e6fe] text-[#1e265c]':slotProps.value == '0'},{'bg-[#fcdfc0] text-[#442511]':slotProps.value == '1'},{'bg-[#c7f3de] text-[#183726]':slotProps.value == '2'}]">
                            {{ slotProps.value == '0' && "Non justifiée" }}
                            {{ slotProps.value == '1' && "En cours de validation" }}
                            {{ slotProps.value == '2' && "Justifiée" }}
                        </span>
                    </span>
                    <span v-else-if="slotProps.cellNumber == 3">
                        <JustifyException :motifs="motifs" :id_exception="slotProps.value.id" :label="slotProps.value.type.label.toLowerCase()"/>
                    </span>
                    <span v-else>{{ slotProps.value }}</span>
                </template>
            </CustomTable>
        </div>
        <!-- <div class="bg-white rounded-lg p-4 mb-3">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-x-1 text-black font-light rounded-md">
                    <span v-bind:class="getActiveClass('Retards')" v-on:click="selectBar('Retards')">Retards</span>
                    <span v-bind:class="getActiveClass('Départ anticipé')" v-on:click="selectBar('Départ anticipé')">Départ anticipé</span>
                    <span v-bind:class="getActiveClass('Absence')" v-on:click="selectBar('Absence')">Absence</span>
                </div>
                <div class="flex items-center gap-x-2">
                    <input type="date" class="p-3 border rounded-md text-black cursor-pointer" v-model="date">
                    <button :disabled="asSend" class="px-5 py-3 rounded-md border text-black" v-on:click="getAllUserException">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Actualiser</span>
                    </button>
                </div>
            </div>
        </div> -->
        <!-- <div class="p-4 rounded-lg bg-white">
            <h2 class="text-black text-[16px] font-light">{{ active }}</h2>
            <p class="mt-2 text-[#929292] font-extralight">
                Ensemble des {{ active }} enregistrés pour l'utilisateur connecté
            </p> 
            <div class="mt-6">
                <table v-if="!isload" class="w-full">
                    <thead class="w-full">
                        <tr class="text-black flex justify-between w-full py-3">
                            <th class="font-extralight w-[14%] pl-[13px]">ID Exception</th>
                            <th class="font-extralight w-[14%] pl-[13px]">Date création</th>
                            <th class="font-extralight w-[14%] pl-[13px]">Début exception</th>
                            <th class="font-extralight w-[16%] pl-[13px]">Status</th>
                            <th class="font-extralight w-[14%] pl-[13px]">Action</th>
                        </tr>
                    </thead>
                    <tbody v-if="activeTab.length != 0" class="w-full flex flex-col gap-y-2">
                        <tr class="text-black bg-[#f9fafb] font-extralight rounded-lg flex items-center justify-between w-full py-3" v-for="abs in activeTab" :key="abs.id">
                            <td class="w-[14%] pl-[13px]">{{ abs["id"] }}</td>
                            <td class="w-[14%] pl-[13px]">{{ abs["created_at"].split("T")[0] }}</td>
                            <td class="w-[14%] pl-[13px]">{{ abs["date_start"] }}</td>
                            <td class="w-[16%] pl-[13px]">
                                <span class="py-2 px-3 rounded-2xl inline-flex items-center gap-x-2" :class="getStatusBgColors(abs['state'],abs['is_perm'])">
                                    <div class="h-[6px] w-[6px] rounded-full" :class="getDotColors(abs['state'],abs['is_perm'])"></div>
                                    <span :class="getStatusColors(abs['state'],abs['is_perm'])">{{ getStatus(abs["state"],abs["is_perm"]) }}</span>
                                </span>
                            </td>
                            <td class="w-[14%] pl-[18px]">
                                <JustifyException :id_exception="abs['id']" :id_type="abs['type_id']"/>
                            </td>
                        </tr>
                    </tbody>
                    <tr v-else class= "text-black bg-[#f9fafb] font-extralight rounded-lg flex justify-center w-full py-20">
                            Aucune donnée....
                    </tr>
                </table>
            </div>
        </div> -->
    </div>
</template>
<script>
import API from "../../service/API.js"
// import {Loader2} from "lucide-vue-next";
import CustomTable from "@/components/tables/Custom-table.vue";
import JustifyException from "@/components/create/justify-exception.vue";
import {createColumnHelper} from "@tanstack/vue-table";
import {SlidersHorizontal,RefreshCw,FolderUp,FlagTriangleLeft,X} from "lucide-vue-next";
import gsap from "gsap";
import Swal from "sweetalert2";
import { convertirDateEnFrancais } from "@/utils/date-format.js";

const columnHelper = createColumnHelper();
const columnsException = [
  columnHelper.accessor(row => row.id, {
    id: 'id',
    header: "ID",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.date_start, {
    id: 'Dateexcept',
    header: "Date de l'exception",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.state, {
    id: 'state',
    header: 'Status',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row, {
    id: 'action',
    header: 'Action',
    cell: info => info.getValue(),
  }),
];
export default{
    name:'MyException',
    components:{
        CustomTable,
        SlidersHorizontal,
        RefreshCw,
        FlagTriangleLeft,
        JustifyException,
        X,FolderUp
    },
    data(){
        return {
            activeTab:[],
            columnn: columnsException,
            actu_load: false,
            show_advanced: false,
            absence:[],
            departAnticipe:[],
            retard:[],
            motifs:[],
            isload : true,
            active:"Absence",
            date:""
        }
    },
    mounted(){
        this.getAllUserException();
        this.getMotif();
    },
    methods:{
        formatDate(date){return convertirDateEnFrancais(date)},
        getAllUserException(type = null){
            this.isload = true;
            if(type == 'refresh') this.actu_load = true;
            const date = new Date();
            const years = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2,0);
            const day = date.getDate().toString().padStart(2,0);
            const id = localStorage.getItem("userId") ?? this.$store.getters.userId;
            const formData = new FormData();
            formData.append('date',this.date ? `${this.date.split("-")[0]}-${this.date.split("-")[1]}-01` : `${years}-${month}-${day}`);
            API.post("/getUserExceptions/"+id,formData)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message);
                const {r,a,d} = res.data["data"];
                const retard = r.filter((item) => item.requests.length == 0);
                const absence = a.filter((item) => item.requests.length == 0);
                const depart = d.filter((item) => item.requests.length == 0);
                this.retard = retard;
                this.absence = absence;
                this.departAnticipe = depart;
                this.activeTab = this.active == "Absence" ? absence : (this.active == "Retards" ? retard : depart);
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.isload = false;
                if(type == 'refresh') this.actu_load = false;
            })
        },
        selectfilter(value){
            if(this.active == value) return;
            this.active = value;
            this.activeTab = value == "Absence" ? this.absence : (this.active == "Retards" ? this.retard : this.departAnticipe);
        },
        getMotif(){
            API.get("/getTypesAndMotifs")
            .then((data)=>{
                this.motifs = data.data["motifs"].filter((el)=> el["is_leave"] != 1)
            })
            .catch(e=>{console.log(e)})
        },
        beforeEnterBox(el){
            gsap.set(el, {
                xPercent: -50,
                scale: 0.97,
                y: -10,
                opacity: 0
            });
        },
        enterBox(el, done){
            gsap.to(el, {
                scale: 1,
                y: 0,
                opacity: 1,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leaveBox(el, done){
            gsap.to(el, {
                scale: 0.95,
                y: -10,
                opacity: 0,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
    }
}
</script>